
// Line of a pending warehouse order: product | quantity | measure of that quantity | total in product units.
// Everything comes from the values stored on the line itself.
class BuyOrderWarehouseOrderLineCell extends UITableViewCell
{
    private productLabel:MUILabel = null;
    private quantityLabel:MUILabel = null;
    private measureLabel:MUILabel = null;
    private productQuantityLabel:MUILabel = null;

    private nf = MUIWebApplication.sharedInstance().delegate.numberFormatter as MIONumberFormatter;

    awakeFromHTML(){
        this.productLabel = MUIOutlet(this, "product-lbl", "MUILabel");
        this.quantityLabel = MUIOutlet(this, "quantity-lbl", "MUILabel");
        this.measureLabel = MUIOutlet(this, "measure-lbl", "MUILabel");
        this.productQuantityLabel = MUIOutlet(this, "product-quantity-lbl", "MUILabel");

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    set item(line:WarehouseOrderLine){
        this.productLabel.text = line.productName;
        this.quantityLabel.text = this.nf.stringFromNumber(line.quantity);
        this.measureLabel.text = this.measureString(line);
        this.productQuantityLabel.text = this.nf.stringFromNumber(line.productQuantity) + " " + this.productMeasureString(line);
    }

    // What one unit of "quantity" is: an input format ("Caja (4 Cont)"), a container ("Cont (75cl)") or a plain unit ("Kg")
    private measureString(line:WarehouseOrderLine) : string {
        if (line.inputFormatName != null) {
            let text = line.inputFormatName;
            if (line.inputFormatQuantity != null) text += " (" + this.nf.stringFromNumber(line.inputFormatQuantity) + " " + this.productMeasureString(line) + ")";
            return text;
        }

        if (line.quantityMeasureType == MeasureUnitType.Container) return this.containerString(line);
        return MeasureUnits.toString(line.quantityMeasureType);
    }

    // Measure of the product itself, used by the total: "Cont" for containers, else its unit
    private productMeasureString(line:WarehouseOrderLine) : string {
        return line.productMeasureType == MeasureUnitType.Container ? MeasureUnits.toString(MeasureUnitType.Container) : MeasureUnits.toString(line.productMeasureType);
    }

    private containerString(line:WarehouseOrderLine) : string {
        let text = MeasureUnits.toString(MeasureUnitType.Container);
        if (line.productContainerQuantity != null) text += " (" + this.nf.stringFromNumber(line.productContainerQuantity) + MeasureUnits.toString(line.productContainerMeasureType) + ")";
        return text;
    }
}
